module.exports = __webpack_public_path__ + "img/party-rounded.dcc56d1b.svg";